import {
  CButton,
  CCol,
  CForm,
  CFormFeedback,
  CFormInput,
  CFormLabel,
  CImage,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CRow,
} from "@coreui/react-pro";
import { Formik } from "formik";
import { useEffect } from "react";
import * as Yup from "yup";
import SModal from "../../shared/Modal/SModal";

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../reducers";
import { AppDispatch } from "../../../store";
import { ToastSuccess } from "../../shared/toast/Toast";
import { createEntity, updateEntity } from "./levelManagement.api";
import { fetching, resetEntity } from "./levelManagement.reducer";
import { checkErrorInputFile } from "@/components/shared/AvatarUpload/AvatarUploadContainer";
import { cisCameraPlus } from "@coreui/icons-pro";
import CIcon from "@coreui/icons-react";
import { handleUploadImage } from "@/shared/utils/ultils";
import { ILevel, INewLevel } from "@/shared/model/level.model";

interface IBankUpdateProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  levelObj?: ILevel;
}

const BankUpdate = (props: IBankUpdateProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const { initialState } = useSelector(
    (state: RootState) => state.levelsReducer
  );
  const { updateEntitySuccess } = initialState;
  const { visible, setVisible, levelObj } = props;
  const handleOnClose = () => {
    setVisible(false);
  };

  useEffect(() => {
    if (updateEntitySuccess) {
      setVisible(false);
      ToastSuccess(
        levelObj
          ? "Cập nhật cấp thành viên thành công"
          : "Tạo cấp thành viên thành công"
      );
      dispatch(resetEntity());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateEntitySuccess]);

  const initialValues: INewLevel = {
    name: "",
    avatar: "",
    fileAvatar: null,
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().trim().required("Không được để trống"),
  });

  const handleFileUploadAvatar = async (
    e: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: (
      field: string,
      value: any,
      shouldValidate?: boolean | undefined
    ) => void
  ) => {
    const inputFiles = e.target.files;
    if (inputFiles && inputFiles[0]) {
      if (!checkErrorInputFile([inputFiles[0]])) return;
      const reader = new FileReader();
      reader.onload = (e) => {
        setFieldValue("fileAvatar", inputFiles[0]);
        setFieldValue("avatar", e.target?.result);
      };
      reader.readAsDataURL(inputFiles[0]);
    }
  };

  const handleRemappingImageValue = async (value: INewLevel) => {
    if (value.fileAvatar) {
      const avatarUrlPromises = await handleUploadImage(value.fileAvatar);
      value.avatar = avatarUrlPromises;
    }
    return value;
  };

  return (
    <SModal
      visible={visible}
      onClose={handleOnClose}
      backdrop="static"
      className="custom-modal"
    >
      <Formik
        initialValues={levelObj || initialValues}
        validationSchema={validationSchema}
        // validateOnChange={false}
        validateOnBlur={false}
        onSubmit={async (value) => {
          const values = await handleRemappingImageValue(value);
          dispatch(fetching());
          if (levelObj) {
            dispatch(updateEntity(values as ILevel));
          } else {
            dispatch(createEntity(values));
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          resetForm,
          setFieldValue,
        }) => (
          <CForm onSubmit={handleSubmit} className="custom-form">
            <>
              <CModalHeader>
                {levelObj ? "Chỉnh sửa cấp thành viên" : "Tạo cấp thành viên"}
              </CModalHeader>
              <CModalBody>
                {/* <CCol xs={12}>
                  <CRow>
                    <CCol xs={12}>
                      <CFormLabel className="fw-bold text-sm mb-2 required-field">
                        Chọn ảnh đại diện cấp thành viên
                      </CFormLabel>
                      <div
                        className="d-flex justify-content-center"
                        style={{ background: "#f6f6f6" }}
                      >
                        <div className="profileImageContainer">
                          <div
                            className="position-relative"
                            style={{ height: 100 }}
                          >
                            {values.avatar ? (
                              <CImage
                                color="secondary"
                                rounded
                                className="avatar-xxl object-fit-cover"
                                src={values.avatar}
                                style={{ width: "100%", height: "100%" }}
                              />
                            ) : (
                              <div
                                className="d-flex flex-column justify-content-center align-items-center"
                                style={{ width: "100%", height: "100%" }}
                              >
                                <CIcon
                                  icon={cisCameraPlus}
                                  className="mb-3"
                                  style={{ width: "33px", height: "33px" }}
                                />
                                <p>Chọn ảnh</p>
                              </div>
                            )}
                          </div>
                          <CFormLabel
                            htmlFor="custom-task-file-input"
                            className={`p-image`}
                          >
                            {values.avatar ? (
                              <CIcon
                                icon={cisCameraPlus}
                                color="secondary"
                                className="upload-button"
                              />
                            ) : (
                              <div className="add-image"></div>
                            )}
                            <input
                              id="custom-task-file-input"
                              className="file-upload"
                              type="file"
                              onClick={(e) => (e.currentTarget.value = "")}
                              onChange={(e) =>
                                handleFileUploadAvatar(e, setFieldValue)
                              }
                              // accept={inputFileTypesAccept}
                              accept="image/*"
                            />
                          </CFormLabel>
                        </div>
                      </div>
                      <CFormFeedback
                        invalid
                        className={
                          !!errors.avatar && touched.avatar
                            ? "d-block"
                            : "d-none"
                        }
                      >
                        {errors.avatar}
                      </CFormFeedback>
                    </CCol>
                  </CRow>
                </CCol> */}

                <CRow className="g-3">
                  <CCol xs="12">
                    <CFormLabel className="mb-6 label-gray-700">
                      Tên cấp thành viên
                    </CFormLabel>

                    <CFormInput
                      className="form-height-44"
                      name="name"
                      autoComplete="off"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      invalid={!!errors.name && touched.name}
                    />
                    <CFormFeedback
                      invalid
                      className={
                        !!errors.name && touched.name ? "d-block" : "d-none"
                      }
                    >
                      {errors.name}
                    </CFormFeedback>
                  </CCol>

                  <CCol xs="6">
                    <CFormLabel className="mb-6 label-gray-700">
                      Chiết khấu
                    </CFormLabel>

                    <CFormInput
                      className="form-height-44"
                      name="rate"
                      autoComplete="off"
                      value={values.rate}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      invalid={!!errors.rate && touched.rate}
                    />
                    <CFormFeedback
                      invalid
                      className={
                        !!errors.rate && touched.rate ? "d-block" : "d-none"
                      }
                    >
                      {errors.rate}
                    </CFormFeedback>
                  </CCol>

                  <CCol xs="6">
                    <CFormLabel className="mb-6 label-gray-700">
                      Phí nâng cấp
                    </CFormLabel>

                    <CFormInput
                      className="form-height-44"
                      name="amount"
                      autoComplete="off"
                      value={values.amount}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      invalid={!!errors.amount && touched.amount}
                    />
                    <CFormFeedback
                      invalid
                      className={
                        !!errors.amount && touched.amount ? "d-block" : "d-none"
                      }
                    >
                      {errors.amount}
                    </CFormFeedback>
                  </CCol>

                  <CCol xs="6">
                    <CFormLabel className="mb-6 label-gray-700">
                      Lượt phân phối
                    </CFormLabel>

                    <CFormInput
                      className="form-height-44"
                      name="quantity"
                      autoComplete="off"
                      value={values.quantity}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      invalid={!!errors.quantity && touched.quantity}
                    />
                    <CFormFeedback
                      invalid
                      className={
                        !!errors.quantity && touched.quantity
                          ? "d-block"
                          : "d-none"
                      }
                    >
                      {errors.quantity}
                    </CFormFeedback>
                  </CCol>
                </CRow>
              </CModalBody>
              <CModalFooter className="d-flex justify-content-end">
                <CButton
                  className="btn-custom minw-120 variant-gray-300"
                  type="button"
                  onClick={() => {
                    resetForm();
                    setVisible(false);
                  }}
                >
                  Huỷ
                </CButton>
                <CButton
                  className="btn-custom minw-120 primary-500"
                  type="submit"
                >
                  Lưu
                </CButton>
              </CModalFooter>
            </>
          </CForm>
        )}
      </Formik>
    </SModal>
  );
};

export default BankUpdate;
